import { ExportToCsv } from "export-to-csv";

export const exportCSV = (options, data) => {
  const csvExporter = new ExportToCsv(options);
  csvExporter.generateCsv(data);
};
